import React from "react";

const ItemCategoryHeader = ({
  search,
  handleSearch,
  handleGetItemCategory,
  isModuleReadWriteAccessForCategoryItems,
  showDeletedItems,
  setShowDeletedItems,
  setPage,
}) => {
  return (
    <header className="todo-header">
      <div className="d-flex align-items-center">
        <a className="todoapp-title link-dark">
          {showDeletedItems ? (
            <button
              className="btn btn-outline text-primary btn-md d-flex align-items-center gap-1"
              onClick={() => {
                setPage(1);
                setShowDeletedItems(false);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                fill="currentColor"
                className="bi bi-chevron-left"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                />
              </svg>
              <p className="mb-0">Back</p>
            </button>
          ) : (
            <h5 className="header-title-font mt-2">Categories</h5>
          )}
          {showDeletedItems && (
            <h5 className="header-title-font mt-2 ms-2">
              Deleted Categories
            </h5>
          )}
          {isModuleReadWriteAccessForCategoryItems && !showDeletedItems && (
            <button
              className="btn btn-sm btn-outline-light flex-shrink-0 d-lg-inline-block ms-3 header-button-shadow"
              data-bs-toggle="modal"
              data-bs-target="#add_new_category"
            >
              Add Category
            </button>
          )}
          {!showDeletedItems && (
            <button
              className="btn btn-sm btn-outline-light flex-shrink-0 d-lg-inline-block ms-3 header-button-shadow"
              onClick={() => {
                setPage(1);
                setShowDeletedItems(true);
              }}
            >
              Show Deleted Categories
            </button>
          )}
        </a>
      </div>
      <div className="todo-options-wrap">
        <span
          className="btn btn-icon btn-flush-dark btn-rounded flush-soft-hover no-caret d-lg-inline-block me-0"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title="dsdsd"
          data-bs-original-title="Refresh"
          onClick={() => {
            handleGetItemCategory();
          }}
        >
          <span className="btn-icon-wrap">
            <span className="feather-icon">
              <i className="ri-refresh-line" title="Refresh business list"></i>
            </span>
          </span>
        </span>
        <div className="v-separator d-lg-inline-block d-none"></div>
        <form className="d-lg-block d-sm-none" role="search">
          <input
            type="text"
            className="form-control"
            placeholder="Search"
            value={search}
            onChange={handleSearch}
          />
        </form>
      </div>
    </header>
  );
};

export default ItemCategoryHeader;
